// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"SetUserDetailsModal_buttonContainer__3qvrM","loadingSpinner":"SetUserDetailsModal_loadingSpinner__3fb4U"};